<template>
    <div class="admin-year-filter">
        <RequestPanel :title="title">
            <template #actions>
                <Select
                    v-model="selectedEmployee"
                    class="admin-year-filter__employee"
                    filterable
                    clearable
                    placeholder="All Employees"
                    @on-change="handleUserChanged"
                >
                    <Option v-for="item in allEmployees" :key="item.key" :value="item.value">
                        {{ item.name }}
                    </Option>
                </Select>
                <Select v-model="selectedYear" class="admin-year-filter__year" @on-change="emitYear">
                    <Option v-for="item in yearOptions" :key="item" :value="item">{{ item }}</Option>
                </Select>
                <slot name="actions" />
            </template>
        </RequestPanel>
    </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';
import moment from 'moment';
import RequestPanel from '@/components/Requests/Dev/shared/RequestPanel.vue';
import { yearOptions, yearRange } from '@/components/Requests/Dev/shared/years';

// Employee + year filter for the admin leave / time dispute lists.
// Emits the same `user-changed` / `date-change` events as the old filters, with the year as the date range.
export default {
    components: { RequestPanel },
    props: {
        title: {
            type: String,
            required: true,
        },
        allEmployees: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedEmployee: this.$route.query.user,
            selectedYear: moment().year(),
        };
    },
    computed: {
        yearOptions,
    },
    created() {
        if (this.$route.query.user) {
            this.$emit('user-changed', this.selectedEmployee);
        }
        this.emitYear(this.selectedYear);
    },
    methods: {
        handleUserChanged(user) {
            this.$emit('user-changed', user);
            try {
                this.$router.replace({ query: null }).catch(() => {});
            } catch (e) {
                Bugsnag.notify(e);
            }
        },
        emitYear(year) {
            this.$emit('date-change', yearRange(year));
        },
    },
};
</script>

<style lang="scss" scoped>
.admin-year-filter {
    &__employee {
        width: 220px;
    }

    &__year {
        width: 120px;
    }
}

@media screen and (max-width: 767px) {
    .admin-year-filter {
        &__employee {
            flex: 1 1 100%;
            width: auto;
        }

        &__year {
            flex: 0 0 100px;
        }
    }
}
</style>
